export class PaymentFee {
    constructor({
        code = null,
        label = null,
        quantity = null,
        price = null,
        priceWithDiscount = null,
    } = {}) {
        this.code = code;
        this.label = label;
        this.quantity = quantity;
        this.price = price;
        this.priceWithDiscount = priceWithDiscount;
    }
}
